/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M12 13V22M12 22L15.5 18.5M12 22L8.5 18.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M3.2 18C1.88484 17.235 1 15.8051 1 14.1674C1 12.1053 2.40285 10.3727 4.30122 9.88197C4.30041 9.83571 4.3 9.78935 4.3 9.7429C4.3 5.46661 7.74741 2 12 2C15.6211 2 18.6584 4.51348 19.4806 7.90009C21.5395 8.69955 23 10.7089 23 13.0613C23 14.8707 22.1359 16.4772 20.8 17.4862"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M12 2C7.74741 2 4.3 5.55187 4.3 9.93333C4.3 9.98093 4.30041 10.0284 4.30122 10.0758C2.40285 10.5786 1 12.3539 1 14.4667C1 16.9704 2.96995 19 5.4 19H17.5C20.5376 19 23 16.4629 23 13.3333C23 10.9231 21.5395 8.86433 19.4806 8.0452C18.6584 4.5753 15.6211 2 12 2Z"
				fill="currentColor"
			/>
			<path
				d="M3.2 18C1.88484 17.235 1 15.8051 1 14.1674C1 12.1053 2.40285 10.3727 4.30122 9.88197C4.30041 9.83571 4.3 9.78935 4.3 9.7429C4.3 5.46661 7.74741 2 12 2C15.6211 2 18.6584 4.51348 19.4806 7.90009C21.5395 8.69955 23 10.7089 23 13.0613C23 14.8707 22.1359 16.4772 20.8 17.4862M12 13V22M12 22L15.5 18.5M12 22L8.5 18.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M23.75 13.3333C23.75 13.2874 23.7495 13.2416 23.7486 13.1959C23.7495 13.1511 23.75 13.1063 23.75 13.0613C23.75 10.5298 22.2594 8.34734 20.1107 7.35337C19.0843 3.82884 15.8445 1.25 12 1.25C7.46613 1.25 3.77223 4.83655 3.55966 9.33328C1.62275 10.0781 0.25 11.9625 0.25 14.1674C0.25 14.217 0.250693 14.2663 0.252071 14.3155C0.250693 14.3658 0.25 14.4161 0.25 14.4667C0.25 17.3633 2.53479 19.75 5.4 19.75H6.93853C6.30828 18.9647 6.35737 17.8142 7.08579 17.0858C7.86684 16.3047 9.13317 16.3047 9.91421 17.0858L10 17.1716V13C10 11.8954 10.8954 11 12 11C13.1046 11 14 11.8954 14 13V17.1716L14.0858 17.0858C14.8668 16.3047 16.1332 16.3047 16.9142 17.0858C17.6426 17.8142 17.6917 18.9647 17.0615 19.75H17.5C20.9727 19.75 23.75 16.8559 23.75 13.3333ZM12.75 13C12.75 12.5858 12.4142 12.25 12 12.25C11.5858 12.25 11.25 12.5858 11.25 13V20.1893L9.03033 17.9697C8.73744 17.6768 8.26256 17.6768 7.96967 17.9697C7.67678 18.2626 7.67678 18.7374 7.96967 19.0303L11.4697 22.5303C11.7626 22.8232 12.2374 22.8232 12.5303 22.5303L16.0303 19.0303C16.3232 18.7374 16.3232 18.2626 16.0303 17.9697C15.7374 17.6768 15.2626 17.6768 14.9697 17.9697L12.75 20.1893V13Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M19.4806 7.90009C21.5395 8.69955 23 10.7089 23 13.0613C23 14.8707 22.1359 16.4772 20.8 17.4862M3.2 18C1.88484 17.235 1 15.8051 1 14.1674C1 12.1053 2.40285 10.3727 4.30122 9.88197C4.30041 9.83571 4.3 9.78935 4.3 9.7429C4.3 5.46661 7.74741 2 12 2C13.9084 2 15.6547 2.69815 17 3.85431M12 13V22M12 22L15.5 18.5M12 22L8.5 18.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M3.2 18C1.88484 17.235 1 15.8051 1 14.1674C1 12.1053 2.40285 10.3727 4.30122 9.88197C4.30041 9.83571 4.3 9.78935 4.3 9.7429C4.3 5.46661 7.74741 2 12 2C15.6211 2 18.6584 4.51348 19.4806 7.90009C21.5395 8.69955 23 10.7089 23 13.0613C23 14.8707 22.1359 16.4772 20.8 17.4862M12 13V22M12 22L15.5 18.5M12 22L8.5 18.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M23.7486 13.1959C23.7495 13.2416 23.75 13.2874 23.75 13.3333C23.75 16.8559 20.9727 19.75 17.5 19.75H17.0615C17.6917 18.9647 17.6426 17.8142 16.9142 17.0858C16.1332 16.3047 14.8668 16.3047 14.0858 17.0858L14 17.1716V13C14 11.8954 13.1046 11 12 11C10.8954 11 10 11.8954 10 13V17.1716L9.91421 17.0858C9.13317 16.3047 7.86684 16.3047 7.08579 17.0858C6.35737 17.8142 6.30828 18.9647 6.93853 19.75H5.4C2.53479 19.75 0.25 17.3633 0.25 14.4667C0.25 14.4161 0.250693 14.3658 0.252071 14.3155C0.250693 14.2663 0.25 14.217 0.25 14.1674C0.25 11.9625 1.62275 10.0781 3.55966 9.33328C3.77223 4.83655 7.46613 1.25 12 1.25C15.8445 1.25 19.0843 3.82884 20.1107 7.35337C22.2594 8.34734 23.75 10.5298 23.75 13.0613C23.75 13.1063 23.7495 13.1511 23.7486 13.1959Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 12.25C12.4142 12.25 12.75 12.5858 12.75 13V20.1893L14.9697 17.9697C15.2626 17.6768 15.7374 17.6768 16.0303 17.9697C16.3232 18.2626 16.3232 18.7374 16.0303 19.0303L12.5303 22.5303C12.2374 22.8232 11.7626 22.8232 11.4697 22.5303L7.96967 19.0303C7.67678 18.7374 7.67678 18.2626 7.96967 17.9697C8.26256 17.6768 8.73744 17.6768 9.03033 17.9697L11.25 20.1893V13C11.25 12.5858 11.5858 12.25 12 12.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
